import { render } from "./AsButton.vue?vue&type=template&id=dd3ff780&scoped=true&ts=true"
import script from "./AsButton.vue?vue&type=script&lang=ts"
export * from "./AsButton.vue?vue&type=script&lang=ts"

import "./AsButton.vue?vue&type=style&index=0&id=dd3ff780&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd3ff780"]])

export default __exports__